import { ApplicationEntity } from "@/model/entity/application-entity"
import { Expose } from "class-transformer"
import { FieldDescriptor, FieldTypeEnum } from "@/model/entity//field-descriptor"

export class News extends ApplicationEntity {
  @FieldDescriptor({ fieldType: FieldTypeEnum.DATE, fieldPrettyName: "entity.news.published_date" })
  public publishedDate: Date
  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.news.title" })
  public title: string
  @FieldDescriptor({ fieldType: FieldTypeEnum.BOOLEAN, fieldPrettyName: "entity.news.active" })
  public active: boolean

  public content: string

  constructor(
    publishedDate: Date = new Date(),
    title: string = "",
    active: boolean = false,
    content: string = "",
    id?: number
  ) {
    super(id)
    this.publishedDate = publishedDate
    this.title = title
    this.active = active
    this.content = content
  }
}
